import React from 'react';
import { injectIntl } from 'react-intl';

import 'Core/views/error/index.scss';

const ErrorComponent = (props) => {
  const { messages } = props.intl;
  return (
    <div className="containerError">
      <div className="containerErrorCenter">
        <div>
          <img src="https://gpstrackit.com/wp-content/uploads/2020/04/Service-Van.gif" />
        </div>
        <div className="containerErrorInternal">
          <div className="containerErrorCenter" style={{display: "contents"}}>
            <div>
              <span className="errorLabelTiitle">404</span>
            </div>
            <div>
              <span className="errorLabelOpps">{messages['page_not_found']}</span>
            </div>
            <div style={{ maxWidth: 400 }}>
              <span className="errorLabelDescription">{messages['page_not_found_message']}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(ErrorComponent);
